export const getAiAgentFlowUrl = () => {
  const isLocal =
    location.host.startsWith('localhost:') || /\.nges\.local(:\d+)?$/.test(location.host);
  return isLocal ? 'http://localhost:8010' : `https://${location.host}/ai-agent-flow/`;
};

export const objectToQueryString = (params) => {
  const queryString = Object.keys(params)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
  return queryString ? `?${queryString}` : '';
};
